angular.module('wbDashboard').controller('FundingActivityDetailControllerAurea',
    ['$scope', '$state', '$filter', '$q', '$uibModal', 'User', 'Message', 'NgTableParams', 'DataService',
function ($scope, $state, $filter, $q, $uibModal, User, Message, NgTableParams, DataService) {
    var uuid = $scope.$stateParams.uuid;

    if (!uuid) {
        $scope.$state.go('base.funding.options');
        return;
    }

    loadActivity();

    function loadActivity() {
        if ($scope.$stateParams.transaction) {
            $scope.a = $scope.$stateParams.transaction;
        } else {
            if (!User.getActivityId(uuid)) {
                User.retrieveActivityId(uuid);
            }
        }
    }
    $scope.$watch(function() { return User.getActivityId(uuid); }, function(activity) {
        if (activity) {
            $scope.a = activity;
        }
    });
    $scope.$watch('a', function(a) {
        if (a) {
            var plaidId;
            // if (a.milestone_id) {
            //     a.ms = User.getMilestones(a.milestone_id);
            // }
            if (a.sub_type === 'securityselection') {
                DataService.retrieveAssetClasses();
            }
            if (a.type === "cash_transaction" && a.sub_type === 'deposit:future_auto') {
                plaidId = a.data.transaction.next_auto_deposit.plaid_institution_id;
            } else if (a.type === "cash_transaction") {
                plaidId = a.data.transaction.cash.plaid_institution_id;
            }
            if (plaidId) {
                User.retrieveBankLogo(plaidId).then(function(bankDisplay) {
                    $scope.pageData.bankLogo = bankDisplay.logo;
                });
            }

        }
    });

    $scope.cancelTransaction = function(a = $scope.a) {
        var type;

        if (a.type === 'cash_transaction') {
            if (a.sub_type === 'deposit' || a.sub_type === 'deposit:auto') {
                type = 'deposit';
            } else if (a.sub_type === 'withdrawal') {
                type = 'withdraw';
            }
        } else if (a.type === 'transfer_transaction') {
            type = 'xfer';
        }

        if (type) {
            $scope.pageData.sending = true;
            User.cancelTransaction(type, {uuid: a.uuid, accountNumber: a.account_number}).then(function (response) {
                return $q.all([User.retrieveActivity({}, true), User.retrieveActivityPending(true), User.retrieveActivityId(a.uuid, true)]);
            }).catch(function (err) {
                Message.set({
                    text:"There was an issue cancelling this transaction. If you continue to have problems, please email support@axosinvest.com.",
                    type: "danger"
                });
            }).finally(function () {
                $scope.pageData.sending = false;
            });
        } else {
            console.log('Not a cancelable transaction.');
        }
    };

    $scope.skipAutoDepositConfirm = function(a = $scope.a) {
        let modalScope = $scope.$new();
        modalScope.a = a;

        var modalInstance = $uibModal.open({
            templateUrl: "skip-auto-deposit-confirm-modal.tpl.html",
            size: 'md',
            scope: modalScope,
            windowClass: 'skip-auto-deposit-confirm-modal'
        });
        modalInstance.result.then(function () {
            $scope.skipAutoDeposit(a);
        }).catch(angular.noop);

    };
    $scope.skipAutoDeposit = function(a = $scope.a) {
        var type;

        if (a.sub_type !== 'deposit:future_auto') {
            //probably never seen
            Message.set({
                text:"Unable to skip this item.",
                type: "warning"
            });
            return;
        }

        var skipToDate = moment(a.event_at).add(1, 'day').format('YYYY-MM-DD');
        var nextDate = [];

        $scope.pageData.sending = true;
        User.skipAutoDeposit(skipToDate).then(function (dates) {
            nextDate = dates;
            return $q.all([User.retrieveActivityPending(true), User.retrieveActivityId(a.uuid, true)]);
        }).then(function (data) {
            var date = moment(nextDate[0]).format('MMM D');
            Message.set({
                text: `Next auto-deposit skipped. Next scheduled auto-deposit on ${date}.`,
                type: "success"
            });
            $scope.$state.go('base.funding.options');
        }).catch(function (err) {
            Message.set({
                text:"There was an issue skipping this auto-deposit. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function () {
            $scope.pageData.sending = false;
        });
    };


    $scope.ordinal = function(input) {
        var n = input % 100;
        return n === 0 ? 'th' : (n < 11 || n > 13) ?
            ['st', 'nd', 'rd', 'th'][Math.min((n - 1) % 10, 3)] : 'th';
    };

    $scope.getAsset = DataService.getAssetClass;
    $scope.moment = moment;
}]);
